import { atom } from 'jotai';

import { PanelType } from '../../../types';

export const activePanelDatasetAtom = atom<PanelType | undefined>('settings');
export const vcListTabIndexDatasetAtom = atom<number>(0);
